let initialState = {
	finalTextOption: ['First item', 'Second item', 'Third item']
};

const sankyQueries = (state = initialState, action) => {
	switch (action.type) {
		case "SET_ENTITY_DATA":
			return {
				...state,
				finalTextOption: action.payload,
			};
            default:
                return state;
        }
    };
export default sankyQueries;